import React, { useState } from 'react';

const RoundCornerDetails = ({ matches }) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className={`table-responsive m-t-30 round-special-timeline-table ${isOpen ? 'open' : ''}`}>
      <table className="match">
        <thead className="thead--green">
          <tr>
            <th>Total Corners</th>
            <th>Total Home Corners</th>
            <th>Total Away Corners</th>
            <th>Minute</th>
            <th>Match Corner Score</th>
            <th className="has-dropdown" onClick={() => setIsOpen(prev => !prev)} />
          </tr>
        </thead>
        <tbody id="roundSpecialTimelineBody">
          {matches.map((match) => (
            <tr key={match.matchMinute}>
              <td>{match.totalCornerScore}</td>
              <td>{match.homeCornerScore}</td>
              <td>{match.awayCornerScore}</td>
              <td>{match.matchMinute}&apos;</td>
              <td colSpan="2">
                {match.matches.map((m) => (
                  <div key={m.matchId} className="round-special team-container">
                    <div className="home-team">{m.homeTeam}</div>
                    <div className="score">{m.homeCornerScore} - {m.awayCornerScore}</div>
                    <div className="away-team">{m.awayTeam}</div>
                  </div>
                ))}
              </td>
            </tr>))
          }
        </tbody>
      </table>
    </div>
  );
};

export default RoundCornerDetails;